/*
 * Copyright © 2017, Rezo Zero
 *
 * This file is part of Suprême NTM.
 *
 * Suprême NTM can not be copied and/or distributed without
 * the express permission of Rezo Zero.
 *
 * @file App.js
 * @author Adrien Scholaert <adrien@rezo-zero.com>
 * @copyright Rezo Zero 2018
 */

import {Router} from 'starting-blocks'
import Nav from './common/Nav'
import TransitionFactory from './factories/TransitionFactory'
import ClassFactory from './factories/ClassFactory'
// import SceneManager from './scene/SceneManager'
import ThreeScene from './scene/ThreeScene'

export default class App {
    constructor () {
        /**
         * @type {ThreeScene|null}
         */
        this.sceneManager = null
        this.router = null
        this.nav = null
        this.isRafInit = false
    }

    init () {
        this.sceneManager = new ThreeScene()

        // New Router instance
        this.router = new Router({
            useCache: true,
            lazyloadEnabled: true,
            classFactory: new ClassFactory(),
            transitionFactory: new TransitionFactory()
        })

        // New Nav instance
        this.nav = new Nav(this.router)

        // Init everything
        this.sceneManager.init()
        this.nav.init()
        this.router.init()

        if (this.sceneManager && this.isRafInit) {
            this.sceneManager.initRaf()
        }
    }

    iniRaf () {
        if (this.isRafInit) return
        this.isRafInit = true

        if (this.sceneManager) {
            this.sceneManager.initRaf()
        }
    }
}



// WEBPACK FOOTER //
// ./webpack/js/App.js